<template>
    <footer
        :class="['md-footer classic', { inner: inner }, fixedZindexCls]"
        :style="colorMapStyle"
    >
        <div class="mls-wrap">
            <MlsDisclaimer
                v-if="!wordPressSSR"
                theme="classic"
                @update="mlsUpdated"
                class="f-col"
            />
        </div>
        <div
            class="footer-container"
            :style="{ backgroundColor: bgColor, color: fontColor }"
        >
            <div class="mg-container">
                <div class="main-content">
                    <div class="left-content">
                        <p class="menu-title">{{ $t('md-footer.site_Map') }}</p>
                        <ul class="main-menu" role="navigation" :style="useMenuStyle">
                            <menu-item
                                v-for="(menu, index) in z_menus"
                                :key="index"
                                :selfKey="'menu-' + index"
                                :expandKey="expandKey"
                                :menu="menu"
                                :useMenuStyle="useMenuStyle"
                                :useSubMenuStyle="useSubMenuStyle"
                                @updateExpandKey="updateExpandKey"
                            />
                        </ul>
                    </div>
                    <div class="right-content">
                        <div class="site-logo" v-if="logos.length > 0">
                            <template v-for="(logo, index) in validLogos">
                                <a
                                    v-if="logo.logo.href"
                                    :key="index"
                                    :href="logo.logo.href"
                                    aria-label="site logo"
                                    rel="noopener noreferrer"
                                >
                                    <site-img
                                        class="logo-item"
                                        :src="logo.logo"
                                        alt="site logo"
                                        :style="{ height: size / 100 + 'em' }"
                                        :ssrInitSize="30"
                                        dir="height"
                                    />
                                </a>
                                <site-img
                                    v-else
                                    class="logo-item"
                                    :key="'key-' + index"
                                    :src="logo.logo"
                                    alt="site logo"
                                    :style="{ height: size / 100 + 'em' }"
                                    :ssrInitSize="30"
                                    dir="height"
                                />
                            </template>
                        </div>
                        <template v-if="!!companyInfo">
                            <p v-if="!!companyInfo.name" class="co-name">
                                <span
                                    :style="useBroNameStyle"
                                    v-html="companyInfo.name"
                                >
                                </span>
                            </p>
                        </template>
                        <p class="detail-info">
                            <span
                                :style="useAgentNameStyle"
                                v-if="
                                    !!footerAgentInfo.firstName ||
                                        !!footerAgentInfo.lastName
                                "
                                class="detail-name"
                            >
                                {{ footerAgentInfo.firstName || '' }}
                                {{ footerAgentInfo.lastName || '' }}
                            </span>
                            <span
                                :style="useAgentLicenseStyle"
                                v-if="!!footerAgentInfo.license"
                                class="detail-license"
                            >
                                {{ global.licenseName }}
                                {{ footerAgentInfo.license }}
                            </span>
                        </p>
                        <p class="detail-info">
                            <span
                                v-if="!!footerAgentInfo.phone"
                                class="detail-phone"
                                :style="useAgentPhoneStyle"
                            >
                                <a
                                    :href="'tel:' + footerAgentInfo.phone"
                                    target="_top"
                                    rel="noopener noreferrer"
                                >
                                    {{ $ft.formatPhone(footerAgentInfo.phone) }}
                                </a>
                            </span>
                            <span
                                v-if="!!footerAgentInfo.email"
                                class="detail-email"
                                :style="useAgentEmailStyle"
                            >
                                <a
                                    :href="'mailto:' + footerAgentInfo.email"
                                    :title="$t('common:link.mailtoTitle')"
                                    :aria-label="
                                        $t('common:link.mailtoAriaLabel', {
                                            email: footerAgentInfo.email
                                        })
                                    "
                                    rel="noopener noreferrer"
                                >
                                    {{ footerAgentInfo.email }}
                                </a>
                            </span>
                        </p>
                        <template v-if="subOwnerInfo">
                            <p class="detail-info">
                                <span
                                    v-if="
                                        !!subOwnerInfo.firstName ||
                                            !!subOwnerInfo.lastName
                                    "
                                    class="detail-name"
                                    :style="useAgentNameStyle"
                                >
                                    {{ subOwnerInfo.firstName || '' }}
                                    {{ subOwnerInfo.lastName || '' }}
                                </span>
                            </p>
                            <p class="detail-info">
                                <span
                                    v-if="!!subOwnerInfo.phone"
                                    class="detail-phone"
                                    :style="useAgentPhoneStyle"
                                >
                                    <a
                                        :href="'tel:' + subOwnerInfo.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >
                                        {{
                                            $ft.formatPhone(subOwnerInfo.phone)
                                        }}
                                    </a>
                                </span>
                                <span
                                    v-if="!!subOwnerInfo.email"
                                    class="detail-email"
                                    :style="useAgentEmailStyle"
                                >
                                    <a
                                        :href="'mailto:' + subOwnerInfo.email"
                                        :title="$t('common:link.mailtoTitle')"
                                        :aria-label="
                                            $t('common:link.mailtoAriaLabel', {
                                                email: subOwnerInfo.email
                                            })
                                        "
                                        rel="noopener noreferrer"
                                    >
                                        {{ subOwnerInfo.email }}
                                    </a>
                                </span>
                            </p>
                        </template>
                        <div
                            v-if="getAddressInfo"
                            class="detail-addr"
                            :style="useBroAddrStyle"
                            v-html="getAddressInfo"
                        ></div>

                        <template v-if="footerAgentCustomContent">
                            <div
                                class="custom-content"
                                :style="{ color: fontColor }"
                                v-html="
                                    formatFontSize(footerAgentCustomContent)
                                "
                            ></div>
                        </template>
                        <closely-app-download useModule="md-footer" />
                        <div class="detail-info">
                            <template
                                v-if="
                                    footerAgentInfo &&
                                        Array.isArray(
                                            footerAgentInfo.disclaimerList
                                        )
                                "
                            >
                                <p
                                    v-for="(
                                        file, index
                                    ) in footerAgentInfo.disclaimerList"
                                    class="detail-file"
                                    :key="index + 'mainfile'"
                                >
                                    <a
                                        :href="file.url"
                                        rel="noopener noreferrer"
                                    >
                                        {{ file.name.split('.')[0] }}
                                    </a>
                                </p>
                            </template>
                            <!--  sub file -->
                            <template v-if="subOwnerHasDisclaimer">
                                <p
                                    v-for="(
                                        file, index
                                    ) in subOwnerInfo.disclaimerList"
                                    :key="index + 'subfile'"
                                    class="detail-file"
                                >
                                    <a
                                        :href="file.url"
                                        rel="noopener noreferrer"
                                    >
                                        {{ file.name.split('.')[0] }}
                                    </a>
                                </p>
                            </template>
                        </div>
                        <div
                            class="no-mls-disclaimer texas-mls"
                            v-if="hasTeaxsMls"
                        >
                            <a
                                href="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-3.pdf"
                                target="_blank"
                                :title="$t('md-footer.realEstateConsumer')"
                                rel="noopener noreferrer"
                            >{{ $t('md-footer.realEstateConsumer') }}</a>
                        </div>
                        <div
                            v-if="noMlsDisclaimers.length > 0"
                            class="no-mls-disclaimer"
                        >
                            <div
                                class="claimer"
                                v-for="(noMls, index) in noMlsDisclaimers"
                                :key="index"
                                v-html="noMls.label"
                            ></div>
                        </div>
                        <div
                            v-if="socialNetworksInfo.length > 0"
                            class="share-links"
                        >
                            <a
                                v-for="(social, index) in socialNetworksInfo"
                                :key="social.id + '-' + index"
                                class="share-item"
                                :style="useCopyStyle"
                                :href="social.url"
                                :aria-label="social.socialNetwork"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i class="iconfont" :class="social.icon"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <a class="md-footer_notshare" v-if="isDoNotShareShow" href="/site/dsar">{{ $t('md-footer.doNotShare') }} --&gt; </a>
            <div v-if="!hideCopyRight" class="copyright" :style="useCopyStyle">
                <div class="mg-container">
                    <template v-if="gfFlag != '1'">
                        <p
                            class="pt-content"
                            v-if="showCopyright"
                            v-html="
                                $t('md-footer.madeInAndCopyright', {
                                    chimeLink,
                                    year
                                })
                            "
                        ></p>
                        <p class="pt-content">
                            <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                        </p>
                    </template>
                    <p v-else class="pt-content">
                        {{ $t('md-footer.geographicFarmingLlc', { year }) }}
                        <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '.././index.scss';

@mixin mobile() {
    .main-content .left-content {
        display: none;
    }

    .main-content {
        padding-bottom: 20px;

        .right-content {
            text-align: left;
            width: 100%;

            .site-logo {
                font-size: 20px;
                justify-content: flex-start;

                .logo-item {
                    margin: 0 20px 20px 0;

                    & + .logo-item {
                        margin-left: 0;
                    }
                }
            }

            .detail-info {
                margin-top: 10px;
                font-size: 14px;

                span {
                    display: block;
                    word-break: break-word;
                    margin-top: 4px;

                    &::after {
                        display: none;
                    }
                }

                .detail-addr {
                    margin-top: 10px;
                }
            }

            .download-closely {
                .code-title {
                    margin-top: 20px;
                    margin-bottom: 10px;
                }
            }
        }
    }

    .copyright p.pt-content {
        padding: 10px 0;
        line-height: 1.2;
        height: auto;

        .policy-tos {
            float: none;
        }
    }
}

.md-footer.classic {
    &.fixed {
        position: fixed;
        bottom: 0;
        width: 100%;

        &.inner {
            position: absolute;
        }
    }

    .fair-house-logo {
        vertical-align: text-bottom;
        margin: 0 5px;
        padding-top: 5px;
    }

    .footer-container {
        padding-top: 30px;
        @include color-theme('background-color');
    }

    .main-content {
        display: flex;
        padding-bottom: 30px;

        .left-content {
            padding-right: 50px;
            max-width: 50%;

            .menu-title {
                font-family: var(--font-bold);
                font-size: 14px;
                line-height: 1.43;
            }

            .main-menu {
                .menu-item {
                    margin-top: 10px;
                    line-height: 1.43;
                    padding-left: 0;

                    .footer-menu {
                        max-width: 100%;
                        display: flex;

                        &:hover {
                            text-decoration: underline;
                        }

                        &.down {
                            color: #fff !important;
                        }

                        .menu-label {
                            margin-right: 2px;
                        }

                        .icon-arrow-down {
                            font-size: inherit;

                            &:before {
                                transform: scale(0.8);
                                display: inline-block;
                            }
                        }

                        &.down {
                            .icon-arrow-down:before {
                                transform: rotate(180deg) scale(0.8);
                            }
                        }
                    }

                    .footer-submenu {
                        .sub-menu {
                            line-height: 0.8;

                            &:hover a {
                                text-decoration: underline;
                            }

                            .submenu-text {
                                line-height: 1.67;
                            }
                        }
                    }
                }
            }
        }

        .right-content {
            text-align: right;
            flex: 1;

            .site-logo {
                font-size: 34px;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-end;

                .logo-item {
                    margin-bottom: 30px;
                    height: 1em;
                }

                & > *:not(:first-child) {
                    margin-left: 30px;
                }
            }

            .co-name {
                font-size: 16px;
                line-height: 1.25;
                font-family: var(--font-bold);
            }

            .detail-addr {
                font-size: 13px;
                line-height: 1.2;
                font-family: var(--font-bold);
                opacity: 0.8;
                margin-top: 20px;
            }

            .detail-file {
                color: #aaa;
                cursor: pointer;
                opacity: 0.8;
            }

            .detail-info {
                margin-top: 10px;
                line-height: 1.2;

                span {
                    display: inline-block;
                    max-width: 100%;
                    word-break: break-word;

                    &::after {
                        content: '|';
                        display: inline-block;
                        // font-size: 15px;
                        line-height: 1;
                        height: 14px;
                        position: relative;
                        color: currentColor;
                        left: 7px;
                        margin-right: 10px;
                    }
                }

                & > :last-child:after {
                    display: none;
                }
            }

            @include no-mls-disclaimer;

            .share-links {
                margin-top: 21px;

                .share-item {
                    color: #aaa;

                    &:hover {
                        color: #fff;
                    }

                    .icon-font {
                        font-size: 18px;
                    }

                    & + .share-item {
                        margin-left: 15px;
                    }
                }
            }

            .download-closely {
                .code-title {
                    margin: 25px 0px 15px;
                }

                .code-wrapper {
                    justify-content: end;
                    margin-bottom: 15px;

                    .android {
                        margin-left: 30px;
                    }
                }
            }
        }
    }

    .copyright {
        border-top: 1px solid rgba(255, 255, 255, 0.1);

        p.pt-content {
            height: 34px;
            line-height: 34px;
            font-size: 12px;
            color: #aaa;

            .policy-tos {
                // float: right;
                @include media-800 {
                    float: none;
                }
            }

            a {
                white-space: nowrap;
            }
        }

        .bottom-declaimer-container {
            padding-top: 10px;

            .declaimer {
                font-size: 13px;
                line-height: 20px;
                color: #c8c8c8;
                padding-bottom: 15px;
            }
        }
    }

    @include media-1080 {
        .main-content .left-content {
            display: none;
        }
    }

    @include media-600 {
        @include mobile();
    }

    &.inner {
        @include mobile();
        padding-top: 0;

        .mls-wrap {
            padding-top: 30px;
        }
        .footer-container {
            padding: 50px var(--inner-padding, 20px);
        }
        .main-content .right-content .download-closely .code-wrapper {
            justify-content: flex-start;
        }
    }
    .mls-wrap {
        background-color: #f4f4f4;
        padding-bottom: 30px;
    }
}
</style>
